package one.healthium.insights.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TipsConfigDto(
    @SerialName("backgroundColor") val backgroundColor: String? = null,
    @SerialName("textColor") val textColor: String? = null,
)
